var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/ModelsTree/VersionButton/buttons/ErrorButton.tsx";

/* eslint-disable react/forbid-component-props */
import React from 'react';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CloudOff } from '@mui/icons-material';
import clsx from 'clsx';
import { useBaseIconStyles } from "./buttonStyles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ErrorButton = /*#__PURE__*/React.memo(function (_ref) {
  var className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick;
  var classes = useErrorButtonStyles();
  var baseIconClasses = useBaseIconStyles();
  var iconClassName = clsx(baseIconClasses.root, classes.icon);
  return /*#__PURE__*/_jsxs(Button, {
    disableRipple: true,
    onClick: onClick,
    size: "small",
    className: clsx(className, classes.root),
    children: [children, " ", /*#__PURE__*/_jsx(CloudOff, {
      className: iconClassName
    })]
  });
});
ErrorButton.displayName = 'ErrorButton';
var useErrorButtonStyles = makeStyles({
  root: {
    color: '#D9575F'
  },
  icon: {
    color: '#D9575F'
  }
});